import React from 'react';
import {
  H3,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../core';

interface ReasonForAppointmentProps {
  reasonForAppointment: string;
}

const ReasonForAppointment: React.FC<ReasonForAppointmentProps> = (
  props: ReasonForAppointmentProps
) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <H3 text="REASON FOR APPOINTMENT" />
      <Paragraph text={props.reasonForAppointment} />
    </StackedColumn>
  );
};

export default ReasonForAppointment;
